<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">會員資料</span>
          </div>
          <b-button class="border float-right" to="/admin/users">返回</b-button>
        </template>
        <b-card-title>
          基本資料
          <b-button class="float-right" variant="info" size="sm" :to="`/admin/users/${this.uid}/edit`">編輯會員資料</b-button>
        </b-card-title>
        <b-card-body>
          <b-card-group>
            <b-card class="text-center" header="會員帳號" :title="username"></b-card>
            <b-card class="text-center" header="會員名稱" :title="name"></b-card>
            <b-card class="text-center" header="註冊時間" :title="registTime"></b-card>
          </b-card-group>
          <b-card-group>
            <b-card class="text-center" header="連絡電話" :title="tel"></b-card>
            <b-card class="text-center" header="電子信箱" :title="email"></b-card>
            <b-card class="text-center" header="學號" :title="schoolNum"></b-card>
          </b-card-group>
        </b-card-body>
        <b-card-title >消費紀錄</b-card-title>
        <b-card-sub-title class="ml-2">共有 {{rows}} 筆訂單</b-card-sub-title>
        <b-card-body>
          <b-table
            id="deliver-table"
            bordered
            show-empty
            empty-text="尚無會員資料"
            hover
            :items="items"
            :fields="fields"
            :busy="isBusy"
            responsive="md"
          >
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(ops)="data">
              <b-link :to="`/admin/deliver/${data.item.id}/view`">查看訂單</b-link>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            per-page="10"
            aria-controls="deliver-table"
            class="float-right"
          ></b-pagination>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import QueryString from 'querystring'
import { Payments, DeliverStates } from '../../library/Var.js'
export default {
  data () {
    return {
      isBusy: false,
      username: '',
      name: '',
      registTime: '',
      tel: '',
      email: '',
      schoolNum: '',
      currentPage: 1,
      rows: 0,
      total: 0,
      items: []
    }
  },
  computed: {
    uid () {
      return this.$route.params.id
    },
    fields () {
      return [
        { key: 'uqid', label: '訂單編號', tdClass: 'text-center' },
        { key: 'time', label: '下單時間', tdClass: 'text-center' },
        { key: 'orderer', label: '購買人姓名', tdClass: 'text-center' },
        { key: 'receiver', label: '取貨人姓名', tdClass: 'text-center' },
        { key: 'total', label: '訂單金額', tdClass: 'text-center' },
        { key: 'pay', label: '支付方式', tdClass: 'text-center' },
        { key: 'state', label: '訂單狀態', tdClass: 'text-center' },
        { key: 'ops', label: '操作', tdClass: 'text-center' }
      ]
    },
    query () {
      const obj = {
        page: this.currentPage,
        each: 10,
        buyer_id: this.uid
      }
      const str = QueryString.stringify(obj)
      return `?${str}`
    }
  },
  methods: {
    async fetch () {
      this.busy = true
      const { data: { username, name, tel, email, school_num: num, registed_time: time } } = await this.$api.getUserById(this.uid)
      this.username = username
      this.name = name
      this.tel = tel
      this.email = email
      this.schoolNum = num
      this.busy = false
      this.registTime = moment(time).format('YYYY/MM/DD HH:mm:ss')
      const { data, headers } = await this.$api.getDel(this.query)
      this.rows = headers['shop-option-total']
      this.items = data.map(item => {
        const payment = Payments.find(item => item.value === item.pay_type)
        return {
          id: item.id,
          uqid: item.uqid,
          time: moment(item.time).format('YYYY/MM/DD HH:mm:ss'),
          orderer: item.orderer,
          receiver: item.receiver,
          total: item.total,
          pay: payment ? payment.name : '無',
          state: DeliverStates[item.state] || '異常'
        }
      })
    }
  },
  mounted () {
    this.fetch()
  },
  watch: {
    query () {
      this.fetch()
    }
  }
}
</script>
